import { observer } from "mobx-react";
import React, { useEffect } from "react";
import Loader from "react-loader-spinner";
import VaultStore from "stores/VaultStore";
import Button from "components/Button/Button";
import { PoolData } from "types";
import Ram from "../../Ram";
import { loaderColor } from "../../../helpers/constants";
import "./UserSection.scss";

type Props = {
  pool: PoolData;
};

function UserSection({ pool }: Props) {
  const { poolId, stakingTokenName } = pool;
  const userPoolData = VaultStore.userPoolData.get(poolId);
  const poolData = VaultStore.poolData.get(poolId);
  const { userAPY } = VaultStore;

  const APY = userAPY ? (!isNaN(userAPY) ? userAPY : 0) : 0;
  useEffect(() => {
    if (!userPoolData) {
      VaultStore.fetchUserPoolData("0");
    }
  }, [userPoolData, poolId]);

  const elmnt = document.getElementById("section-ram-user");
  const width = (elmnt && elmnt.offsetWidth) || 0;

  // Dont have data yet? Show loader.
  if (!userPoolData || !poolData) return <Loader type="MutatingDots" color={loaderColor} />;
  const { pendingRAM, pendingYGY, boostAmount, amount: userStakeAmount } = userPoolData;
  const { totalStaked } = poolData;
  const shareOfTotal = userStakeAmount && (userStakeAmount / totalStaked) * 100;

  return (
    <div className="section-user">
      <div className="section-title section-title-user">user statistics</div>
      <div id="section-ram-user" className="section-ram">
        {<Ram transformValue={Math.min(80, APY)} parentWidth={width} />}
        <div className="apy">APY {APY.toFixed(0)}%</div>
      </div>
      <div className="reward-container">
        <div className="reward-statuses">
          <div className="section-item top-level-item">
            <div className="section-item-title">
              rewards
              <br /> <span className="section-item-value">{pendingRAM ? pendingRAM.toFixed(10) : 0.0}</span> RAM
            </div>
          </div>
        </div>
        <Button
          type="normal"
          className={`interaction-button top-level-item ${!pendingRAM && !pendingYGY ? "disabled" : null}`}
          onClick={() => VaultStore.getRewards(pool.poolId)}
        >
          Claim rewards
        </Button>
      </div>
      <div className="section-item top-level-item">
        <div className="section-item-title">staked</div>
        <div className="section-item-value">
          {userStakeAmount ? userStakeAmount.toFixed(8) : 0.0}
          <span className="staked-percent">({shareOfTotal && !isNaN(shareOfTotal) ? shareOfTotal.toFixed(2) : 0}%)</span>
          <div style={{ fontSize: "12px" }}>{stakingTokenName}</div>
        </div>
      </div>
      <div className="section-item top-level-item">
        <div className="section-item-title">boost:</div>
        <div className="section-item-value">
          <div className="section-item-value">{boostAmount?.toFixed(8)}</div>
          <div style={{ fontSize: "12px" }}>{stakingTokenName}</div>
        </div>
      </div>
    </div>
  );
}

export default observer(UserSection);
